// frontend/src/pages/webmaster/TypesSettings.tsx
import React, { useState } from "react";
import WebmasterSidebar from "../../components/WebmasterSidebar";
import GenericTaxonomyManager from "../../components/GenericTaxonomyManager";
import GenericTaxonomyManagerColor from "../../components/GenericTaxonomyManagerColor";
import API_BASE_URL from "../../config/apiConfig";

type TabKey =
  | "activities"
  | "therapies"
  | "patientTypes"
  | "ageRanges"
  | "childCategories"
  | "therapistCategories"
  | "medicalActivities"
  | "consultTypes"
  ;

const TypesSettings: React.FC = () => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(() => {
    return localStorage.getItem("sidebarCollapsed") === "true";
  });

  const [tab, setTab] = useState<TabKey>("activities");

  return (
    <div className={`dashboard-container ${isCollapsed ? "collapsed" : ""}`}>
      <WebmasterSidebar onCollapseChange={(collapsed) => setIsCollapsed(collapsed)} />

      <div className="page-content">
        <h1 className="page-title">Setări → Tipuri date</h1>

        <div className="tabs">
          <button className={tab === "activities" ? "mod-active" : ""} onClick={() => setTab("activities")}>
            Activități
          </button>
          <button className={tab === "therapies" ? "mod-active" : ""} onClick={() => setTab("therapies")}>
            Tipuri de terapie
          </button>
          <button className={tab === "patientTypes" ? "mod-active" : ""} onClick={() => setTab("patientTypes")}>
            Tipuri pacient
          </button>
          <button className={tab === "ageRanges" ? "mod-active" : ""} onClick={() => setTab("ageRanges")}>
            Intervale vârstă
          </button>
          <button className={tab === "childCategories" ? "mod-active" : ""} onClick={() => setTab("childCategories")}>
            Categorii copil
          </button>
          <button
            className={tab === "therapistCategories" ? "mod-active" : ""}
            onClick={() => setTab("therapistCategories")}
          >
            Categorii terapeuți
          </button>
          <button className={tab === "medicalActivities" ? "mod-active" : ""} onClick={() => setTab("medicalActivities")}>
            Activități medici
            </button>
            <button className={tab === "consultTypes" ? "mod-active" : ""} onClick={() => setTab("consultTypes")}>
            Tipuri consult medical
            </button>
        </div>

        {/* ACTIVITĂȚI */}
        {tab === "activities" && (
          <GenericTaxonomyManager
            title="Activități"
            listUrl={`${API_BASE_URL}/admin/types/activities`}
            createUrl={`${API_BASE_URL}/admin/types/activities`}
            updateUrl={(code: string) => `${API_BASE_URL}/admin/types/activities/${encodeURIComponent(code)}`}
            deleteUrl={(code: string) => `${API_BASE_URL}/admin/types/activities/${encodeURIComponent(code)}`}
            columns={["code", "value", "short_name", "is_active"]}
          />
        )}

        {/* TERAPII */}
        {tab === "therapies" && (
          <GenericTaxonomyManager
            title="Tipuri de terapie"
            listUrl={`${API_BASE_URL}/admin/types/therapy-type`}
            createUrl={`${API_BASE_URL}/admin/types/therapy-type`}
            updateUrl={(code: string) => `${API_BASE_URL}/admin/types/therapy-type/${encodeURIComponent(code)}`}
            deleteUrl={(code: string) => `${API_BASE_URL}/admin/types/therapy-type/${encodeURIComponent(code)}`}
            columns={["code", "value", "short_name", "is_active"]}
          />
        )}

        {/* TIPURI PACIENT */}
        {tab === "patientTypes" && (
          <GenericTaxonomyManager
            title="Tipuri pacient/copil"
            listUrl={`${API_BASE_URL}/admin/types/patient-types`}
            createUrl={`${API_BASE_URL}/admin/types/patient-types`}
            updateUrl={(code: string) => `${API_BASE_URL}/admin/types/patient-types/${encodeURIComponent(code)}`}
            deleteUrl={(code: string) => `${API_BASE_URL}/admin/types/patient-types/${encodeURIComponent(code)}`}
            columns={["code", "value", "is_active"]}
          />
        )}

        {/* INTERVALE VÂRSTĂ */}
        {tab === "ageRanges" && (
          <GenericTaxonomyManager
            title="Intervale de vârstă"
            listUrl={`${API_BASE_URL}/admin/types/age-ranges`}
            createUrl={`${API_BASE_URL}/admin/types/age-ranges`}
            updateUrl={(code: string) => `${API_BASE_URL}/admin/types/age-ranges/${encodeURIComponent(code)}`}
            deleteUrl={(code: string) => `${API_BASE_URL}/admin/types/age-ranges/${encodeURIComponent(code)}`}
            columns={["code", "value", "is_active"]}
          />
        )}

        {/* CATEGORII COPIL */}
        {tab === "childCategories" && (
          <GenericTaxonomyManager
            title="Categorii copil"
            listUrl={`${API_BASE_URL}/admin/types/child-categories`}
            createUrl={`${API_BASE_URL}/admin/types/child-categories`}
            updateUrl={(code: string) => `${API_BASE_URL}/admin/types/child-categories/${encodeURIComponent(code)}`}
            deleteUrl={(code: string) => `${API_BASE_URL}/admin/types/child-categories/${encodeURIComponent(code)}`}
            columns={["code", "value", "is_active"]}
          />
        )}

        {/* CATEGORII TERAPEUȚI (cu COLOR PICKER) */}
        {tab === "therapistCategories" && (
          <GenericTaxonomyManagerColor
            title="Categorii terapeuți"
            listUrl={`${API_BASE_URL}/admin/types/therapist-categories`}
            createUrl={`${API_BASE_URL}/admin/types/therapist-categories`}
            updateUrl={(code: string) =>
              `${API_BASE_URL}/admin/types/therapist-categories/${encodeURIComponent(code)}`
            }
            deleteUrl={(code: string) =>
              `${API_BASE_URL}/admin/types/therapist-categories/${encodeURIComponent(code)}`
            }
            // coloanele: code, value, sort_order, is_active, color
            columns={["code", "value", "sort_order", "is_active", "color"]}
          />
        )}
        {tab === "medicalActivities" && (
            <GenericTaxonomyManager
                title="Activități medici"
                listUrl={`${API_BASE_URL}/admin/types/medical-activities`}
                createUrl={`${API_BASE_URL}/admin/types/medical-activities`}
                updateUrl={(code: string) => `${API_BASE_URL}/admin/types/medical-activities/${encodeURIComponent(code)}`}
                deleteUrl={(code: string) => `${API_BASE_URL}/admin/types/medical-activities/${encodeURIComponent(code)}`}
                columns={["code", "value", "short_name", "is_active"]}
            />
        )}

        {tab === "consultTypes" && (
            <GenericTaxonomyManager
                title="Tipuri consult medical"
                listUrl={`${API_BASE_URL}/admin/types/consult-types`}
                createUrl={`${API_BASE_URL}/admin/types/consult-types`}
                updateUrl={(code: string) => `${API_BASE_URL}/admin/types/consult-types/${encodeURIComponent(code)}`}
                deleteUrl={(code: string) => `${API_BASE_URL}/admin/types/consult-types/${encodeURIComponent(code)}`}
                columns={["code", "value", "short_name", "is_active"]}
            />
        )}
      </div>
    </div>
  );
};

export default TypesSettings;